import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, getElementCenterPos, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend';
import './PopUp_AddSearchFilter.scss';
const ungroupedKey = '###ungrouped###';
export class PopUp_AddSearchFilter extends ComponentSync {
    // ######################### Static #########################
    static show = (e, props) => {
        e.stopPropagation();
        const model = {
            id: 'pop-up__add-search-filter',
            modalPos: { x: -1, y: 1 },
            originPos: getElementCenterPos(e.currentTarget),
            offset: { x: -8, y: 8 },
            onOverlayClick: props.onOverlayClick,
            content: () => _jsx(PopUp_AddSearchFilter, { ...props })
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################### Logic #########################
    onAddFilter = (addOnKey) => {
        this.props.onAddFilter(addOnKey);
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    getAddOns = () => {
        let addOns = this.props.searchContent.getAddOns()
            .filter(addOn => !this.props.currentAddOnKeys.includes(addOn.key));
        if (this.props.addOnFilter)
            addOns = addOns.filter(addOn => this.props.addOnFilter?.(addOn.key));
        return addOns;
    };
    getGroupedAddOns = () => {
        return this.getAddOns().reduce((acc, addOn) => {
            const groupKey = addOn.group ?? ungroupedKey;
            if (!acc[groupKey])
                acc[groupKey] = [];
            acc[groupKey].push(addOn);
            return acc;
        }, {});
    };
    // ######################### Render #########################
    render() {
        const groups = this.getGroupedAddOns();
        return _jsx(_Fragment, { children: Object.entries(groups).map(([key, value]) => this.render_Group(key, value)) });
    }
    render_Group = (key, addOns) => {
        return _jsxs(LL_V_L, { className: 'addon-group', children: [key !== ungroupedKey && _jsx("div", { className: 'addon-group-label', children: key }), addOns.map(addOn => {
                    return _jsx(Button, { variant: 'text', onClick: e => this.onAddFilter(addOn.key), children: addOn.label ?? addOn.key }, addOn.key);
                })] }, key);
    };
}
